'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _server = require('react-dom/server');

var _reactRedux = require('react-redux');

var _nprogress = require('nprogress');

var _nprogress2 = _interopRequireDefault(_nprogress);

var _NProgressTemplate = require('./NProgressTemplate');

var _NProgressTemplate2 = _interopRequireDefault(_NProgressTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NProgressComponent = function (_Component) {
  _inherits(NProgressComponent, _Component);

  function NProgressComponent() {
    _classCallCheck(this, NProgressComponent);

    return _possibleConstructorReturn(this, (NProgressComponent.__proto__ || Object.getPrototypeOf(NProgressComponent)).apply(this, arguments));
  }

  _createClass(NProgressComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          nprogress = _props.nprogress,
          rest = _objectWithoutProperties(_props, ['nprogress']);

      var template = (0, _server.renderToString)(_react2.default.createElement(_NProgressTemplate2.default, rest));

      _nprogress2.default.configure(_extends({}, nprogress, { template: template
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _nprogress2.default.remove();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var tasks = nextProps.tasks;


      if (tasks === 0) {
        _nprogress2.default.done();
      } else {
        _nprogress2.default.inc();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return NProgressComponent;
}(_react.Component);

NProgressComponent.propTypes = {
  nprogress: _propTypes2.default.object
};


function mapStateToProps(state, _ref) {
  var nprogressKey = _ref.nprogressKey;

  return state[nprogressKey || 'nprogress'];
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(NProgressComponent);


//////////////////
// WEBPACK FOOTER
// ./~/redux-nprogress/lib/NProgressComponent.js
// module id = 1091
// module chunks = 2